import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';
import { AbstractMenu } from '../../abstract/menu/menu.component';
import { RemoteTable } from '../table.class';
import { map } from 'rxjs/operators';
import { Viewport } from '../../../../../utils/viewport';
import { Col } from '../../../cols/col.class';

@Component({
   selector: 'app-menu-remote',
   template: `
      <div style="display: flex; justify-content: space-between;">
         <app-reseter [menu]="menu"></app-reseter>
         <div class="count">
            <div class="info filtred" title="Rows count after filtration">
               <span>{{ menu.filtred | async }}</span>
            </div>
               <div class="info all" title="Total Rows count">
                  <span>{{ menu.total | async  }}</span>
               </div>
         </div>
      </div>
      <section class="cols" #Cols>
         <div class="block">
            <app-col-control  *ngFor="let col of cols" 
                              [col]="col" 
                              [ctx]="menu.ctx"
                              class="control"></app-col-control>
         </div>
      </section>
   `,
   styleUrls: ['./menu.component.scss']
})
export class RemoteMenuComponent implements AfterViewInit {
   @Input() menu: RemoteMenu;
   @ViewChild('Cols') colsList: ElementRef<HTMLDivElement>;
   public cols: Col<object>[] = [];

   public colsViewport: Viewport<any>;

   ngAfterViewInit() {
      const { ctx } = this.menu;
      const colsList = this.colsList.nativeElement;
      const visible = ctx.rows.maxVisibleCount - 1;
     


      this.colsViewport = new Viewport(visible);
      this.colsViewport.setHost(colsList, ctx.rows.height);

      requestAnimationFrame(() => {
         this.cols = this.colsViewport.build(ctx.cols.controlable);
      });
   }

}


export class RemoteMenu extends AbstractMenu<RemoteTable<any>> {
   public component = RemoteMenuComponent;

   constructor(ctx: RemoteTable<any> ) {
      super('remote', ctx, ctx.rows.output.pipe(
         map(rows => rows.length)
      ));
   }

   
}